import { render, staticRenderFns } from "./InstaWorksheet.vue?vue&type=template&id=0d5eaf33&scoped=true"
import script from "./InstaWorksheet.vue?vue&type=script&lang=js"
export * from "./InstaWorksheet.vue?vue&type=script&lang=js"
import style0 from "./InstaWorksheet.vue?vue&type=style&index=0&id=0d5eaf33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5eaf33",
  null
  
)

export default component.exports